export const SocialPostTypes = {
    FacebookPagePosts: "facebook-page-posts",
    FacebookPersonalPosts: "facebook-personal-posts",
    LinkedInPersonalPosts: "linkedin-personal-posts",
    TwitterPersonalPosts: "twitter-personal-posts",
};
